import OidcLogin from '../components/OidcLogin';
import { PublicPages } from '../utils/RouteEnums';
import NotFoundRoute from './NotFoundRoute';
import { userRoutes } from './userRoutes';
import { adminRoutes } from './adminRoutes';
import ClientMainWrapper from '../components/client/companyRegistration/context/ClientMainWrapper';
import { publicRoutes } from './publicRoutes';

export interface RouteConfigEx {
    /**
     * @type {string}
     *
     * e.g. '/test3/:paramId', with optional parameter '/test3/:paramId?'
     */
    path: string;
    /**
     * @type {React.ComponentType<any>}
     */
    getComponent: () => React.ReactElement;
    /**
     * Subroutes
     *
     * @type {RouteConfigEx[]}
     */
    routes?: RouteConfigEx[];
    /**
     * index-route
     * @type {boolean}
     */
    index?: boolean;
}

const routes: RouteConfigEx[] = [
    {
        getComponent: () => <ClientMainWrapper />,
        path: '/',
        routes: [...adminRoutes, ...userRoutes, ...publicRoutes],
    },
    {
        getComponent: () => <OidcLogin />,
        path: PublicPages.OIDC_LOGIN,
    },
    {
        getComponent: () => <NotFoundRoute />,
        path: '*',
    },
];

export default routes;
